import React from 'react';
import NavItem from './NavItem.jsx';
import NavGroup from './NavGroup.jsx';

/**
 * Renders a list of nav config items — leaf links and collapsible groups.
 */
export default function NavList({ items, currentRoute, openMap, onToggleOpen, onNavigate, collapsed = false }) {
    return (
        <>
            {items.map((item) => (
                item.children
                    ? (
                        <NavGroup
                            key={item.id}
                            group={item}
                            currentRoute={currentRoute}
                            open={!!openMap[item.id]}
                            onToggleOpen={onToggleOpen}
                            onNavigate={onNavigate}
                            collapsed={collapsed}
                        />
                    )
                    : (
                        <NavItem
                            key={item.route}
                            item={item}
                            currentRoute={currentRoute}
                            onNavigate={onNavigate}
                            collapsed={collapsed}
                        />
                    )
            ))}
        </>
    );
}
